import flag from '../assets/lt-flag.png'

function Flag() {

return <img src={flag} alt="{lt-flag}" className='flag-img' />

}

export default Flag